/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormShareBase
 */
export interface FormShareBase {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof FormShareBase
     */
    createdAt: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof FormShareBase
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof FormShareBase
     */
    code: string;
    /**
     * When will the share expire
     * @type {Date}
     * @memberof FormShareBase
     */
    expirationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof FormShareBase
     */
    formId: string;
    /**
     * 
     * @type {string}
     * @memberof FormShareBase
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FormShareBase
     */
    ownerId: string;
    /**
     * ID of the user that was sharing
     * @type {string}
     * @memberof FormShareBase
     */
    sharedById: string;
    /**
     * 
     * @type {number}
     * @memberof FormShareBase
     */
    status: number;
}

export function FormShareBaseFromJSON(json: any): FormShareBase {
    return FormShareBaseFromJSONTyped(json, false);
}

export function FormShareBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormShareBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'code': json['code'],
        'expirationDate': (new Date(json['expiration_date'])),
        'formId': json['form_id'],
        'id': json['id'],
        'ownerId': json['owner_id'],
        'sharedById': json['shared_by_id'],
        'status': json['status'],
    };
}

export function FormShareBaseToJSON(value?: FormShareBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'code': value.code,
        'expiration_date': (value.expirationDate.toISOString()),
        'form_id': value.formId,
        'id': value.id,
        'owner_id': value.ownerId,
        'shared_by_id': value.sharedById,
        'status': value.status,
    };
}


